var CU;
var top_goal;
var mean_width;
var total_bar_width;
var group;
var app_html = '';
var wrapper_target = "CU_target_cart";
var curr_for = "amount";
var cart_target = '.cart-items';

(function(url, position, callback){
    url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
    if (!window.jQuery) {
        var script = document.createElement("script");
        script.src = url;
        script.async = true; 
        script.onload = function(){ if(typeof callback == 'function') callback(jQuery); };
        document.head.appendChild(script);
    } else {
        if(typeof callback == 'function') callback(jQuery);
    }
}('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function($){
    CU = jQuery.noConflict();
    if(typeof cu_group != "undefined") init_cu();
}));

async function init_cu(){
    if (window.CU_is_initialized) return; 
    window.CU_is_initialized = true;

    if(typeof progress_position != "undefined" && progress_position != "") cart_target = progress_position;

    let real_amount_comma = "{{amount_with_comma_separator}}";
    let real_no_decimal = "{{ amount_no_decimals }}";
    if (currency_format.includes(real_amount_comma)) curr_for = "amount_with_comma_separator";
    else if(currency_format.includes(real_no_decimal)) curr_for = "amount_no_decimals";

    if (localStorage.getItem("drawer") === "true" && !window.location.pathname.includes("/cart")) {
        CU("cart-drawer").addClass("active");
        localStorage.setItem("drawer", "false");
    }
  
    group = JSON.parse(cu_group.replaceAll("#","'"));
    var bar_heading = create_bar_message(group, Number(cart_total));
    observeCartChanges(); 
  
    if(app_html == "") app_html = CU(".CU_embed_html").html();  
    CU(".CU_embed_html").html("");
  
    var g_types = group.group_type.split(",");
    for(var g_type of g_types){
        if(g_type == "cart") init_cart_bar(Number(cart_total));
        
        if(g_type == "product" && window.location.pathname.includes("/products/")){
            var product_target = 'form[action*="/cart/add"]:last';
            if(CU(product_target).length) {
                CU(".CU_target_product").remove();
                CU(product_target).append("<div class='CU_target_product'>" + bar_heading + "</div>");
            }
        }

        if(g_type.includes("fixed")){
            if (CU(".CU_free_shipping_bar_wrapper").length === 0) {
                CU(app_html).find('.CU_free_shipping_bar_wrapper').prependTo("body");
            }
            CU(".CU_free_shipping_bar_title").html(bar_heading);
            if(group.sticky_top_banner && g_type == "fixed_top") CU(".CU_free_shipping_bar_wrapper").addClass("top_stick");
            else if(g_type == "fixed_bottom") CU(".CU_free_shipping_bar_wrapper").addClass("bottom_stick");
            document.documentElement.style.setProperty('--cu-bar-height', '50px');
        }
    }
}

async function init_cart_bar(cart_total) {
    let target = window.location.pathname === '/cart' ? 'form[action="/cart"]:last' : cart_target;
    if(CU(target).length){
        CU(".CU_target_cart").remove();
        CU(target).before("<div class='"+ wrapper_target +"'>" + app_html + "</div>");   
        set_cart_bar(group, "." + wrapper_target, cart_total);
        if(window.location.pathname.includes("/cart")) create_product_slider();   
    }
    manage_gift_in_cart(cart_total);
}

function create_bar_message(group, cart_total){
    var bar_message = '';
    var top_goal = Math.max.apply(Math, group.content.map(function(o) { return o.tier_goal; }));
    for(var tier of group.content) {
        var price_diff = (tier.tier_goal - cart_total).toFixed(2);
        var price_html = "<span>" + currency_format.replace(/\{\{.*?\}\}/, price_diff) + "</span>";
        if(cart_total < tier.tier_goal){
            bar_message = tier.tier_progress_message.replace(/\{.*?\}/g, price_html);
            break;
        } else if(tier.tier_goal == top_goal){
            bar_message = "<span>" + tier.tier_goal_reach_message + "</span>";
            break;
        }
    }
    return bar_message;
}

function set_cart_bar(group, target, cart_total) {
    top_goal = Math.max.apply(Math, group.content.map(function(o) { return o.tier_goal; }));
    group.content.forEach((tier) => {
        var percent = (tier.tier_goal / top_goal) * 100;
        var type_key = tier.tier_type.includes("discount") ? "discount" : tier.tier_type === "free_shipping" ? "shipping" : "gift";
        var icon_html = CU(target + " #" + type_key + "_icon_template").html();
        var $icon = CU(icon_html).css("left", "calc(" + percent + "% - 20px)");
        $icon.find(".icon_" + type_key + "_text").html(tier.tier_description);
        CU(target + " .icon_wrapper").append($icon);
    });
    set_progress_bar(cart_total, target);
}

function set_progress_bar(cart_total, target) {
    var progress_percent = Math.min((cart_total / top_goal) * 100, 100);
    CU(target + " .animated-progress span").css({ "width": progress_percent + "%", "transition": "width 1.2s cubic-bezier(0.4, 0, 0.2, 1)" });
    CU(target + ' .icon_wrapper .icon').each(function() {
        var icon_percent = parseFloat(CU(this).parent().css("left")) / parseFloat(CU(target + " .bar_container").width()) * 100;
        if(progress_percent >= icon_percent) CU(this).addClass("fade_in");
        else CU(this).removeClass("fade_in");
    });
    set_bar_template(group.design);
}

function set_bar_template(design) {
    var f_color = design.foreground_color.replaceAll("'","#");
    var b_color = design.background_color.replaceAll("'","#");
    CU("#CU_container .animated-progress").css({ "background-color": b_color });
    CU("#CU_container .progress-blue span, #CU_container .icon_wrapper .icon.fade_in").css({ "background": f_color });
    if(design.is_gradient){
        CU("#CU_container .progress-blue span").css("background", "linear-gradient(45deg, " + b_color + ", " + f_color + ")");
    }
}

async function create_product_slider(){
    if(typeof products_data == "undefined") return;
    var s_products = JSON.parse(products_data);
    var slides = '';
    CU.each(s_products.productItems, function(key, product) {
        if(!product.title) return;
        slides += '<li class="splide__slide"><div class="product-item-card"><img src="'+ product.image +'"><div class="title_card">'+ product.title +'</div><a onclick="add_to_cart(this)" data-variant-id="'+ product.variant_id +'" class="cu_button">Add</a></div></li>';
    });
    CU(".splide__list").html(slides);
    setTimeout(() => { if(typeof Splide !== 'undefined') new Splide('.splide').mount(); }, 500);
}

function observeCartChanges() {
    const observer = new PerformanceObserver((list) => {
        if (list.getEntries().some(e => e.name.includes('/cart/'))) {
            fetch('/cart.js').then(r => r.json()).then(cart => {
                window.dispatchEvent(new CustomEvent("cart_changed", { detail: cart }));
            });
        }
    });
    observer.observe({ entryTypes: ["resource"] });
}

window.addEventListener("cart_changed", e => {
    var cart_total = e.detail.original_total_price / 100;
    init_cart_bar(cart_total);
});

async function manage_gift_in_cart(cart_total) {
    for(var tier of group.content) {
        if(tier.tier_type == "gift"){
            const cart = await (await fetch('/cart.js')).json();
            const g_found = cart.items.some(item => item.id == tier.tier_gift_variant_id);
            if(cart_total >= tier.tier_goal && !g_found) add_to_cart("", tier.tier_gift_variant_id);
        }
    }
}

function add_to_cart(th, variant_id = '') {
    if(variant_id == '') variant_id = CU(th).data("variant-id");
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({'items': [{'id': variant_id, 'quantity': 1}]})
    }).then(() => { 
        localStorage.setItem("drawer", "true"); 
        window.location.reload(); 
    });
}

/* ================================================================
   DWI — Collection description "Ver más / Ver menos" toggle
   Targets: .dwi-coll-desc + .dwi-read-more-btn
   Shows button only when content actually overflows 115px
   ================================================================ */
document.addEventListener('DOMContentLoaded', function () {
  var desc = document.getElementById('dwi-coll-desc');
  var btn  = document.getElementById('dwi-read-more-btn');
  if (!desc || !btn) return;

  // Measure natural height before collapsing
  var naturalH = desc.scrollHeight;
  var threshold = 130; // px — show button only if taller than this

  if (naturalH <= threshold) {
    // Short description: no button needed
    return;
  }

  // Collapse and show button
  desc.classList.add('dwi-collapsed');
  btn.style.display = 'inline-flex';

  btn.addEventListener('click', function () {
    var isCollapsed = desc.classList.contains('dwi-collapsed');
    var label = btn.querySelector('.dwi-read-more-label');
    if (isCollapsed) {
      desc.classList.remove('dwi-collapsed');
      btn.setAttribute('aria-expanded', 'true');
      if (label) label.textContent = 'Ver menos ↑';
    } else {
      desc.classList.add('dwi-collapsed');
      btn.setAttribute('aria-expanded', 'false');
      if (label) label.textContent = 'Ver más ↓';
      // Scroll back to top of description
      desc.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
});
